import { ICurrency, ICurrencyValuesForm } from '../currencies';
import { ApiResponse, zps_ea_war, zps_ms_ea_war } from '../zps';
import axios from 'axios';

export type ILocation = {
  currencies?: ICurrency[];
  description?: string;
  entid: number;
  gid?: number;
  name?: string;
  sid: number;
  external?: string;
  cbendpoint?: string;
  address?: string;
  postalCode?: string;
  country?: string;
  lat?: number;
  lng?: number;
};

export interface LocationRequest {
  entid?: number;
  currencies?: ICurrencyValuesForm[];
  sid?: number;
  name: string;
  description?: string;
  external?: string;
  cbendpoint?: string;
  address?: string;
  postalCode?: string;
  country?: string;
  lat?: number;
  lng?: number;
}

export interface ILocationResponse extends ApiResponse {
  shops: ILocation[];
  type: string;
  totalRows: number;
}

export interface IHelpdeskLocationResponse extends ApiResponse {
  list: ILocation[];
  type: string;
  totalRows: number;
}

export const fetchLocations = (currencies?: boolean, entid?: number): Promise<ILocationResponse> => {
  const url = `${zps_ea_war}/shop${currencies ? `?currencies=${currencies}` : ''}${entid ? `&entid=${entid}` : ''}`;
  return axios.get<ILocationResponse>(url).then(res => res.data);
};

export const fetchHeldeskLocations = (
  limit: number,
  offset: number,
  totalRows: boolean,
  entid?: number,
  name?: string,
  sid?: number
): Promise<IHelpdeskLocationResponse> => {
  const url =
    `${zps_ms_ea_war}/location?limit=${limit}&offset=${offset}&totalRows=${totalRows}` +
    `${entid ? '&entid=' + entid : ''}` +
    `${name ? '&name=' + name : ''}` +
    `${sid ? '&sid=' + sid : ''}`;

  return axios.get<IHelpdeskLocationResponse>(url).then(res => res.data);
};

export const fetchHeldeskLocationInfo = (
  currencies: boolean,
  entid: number,
  sid: number
): Promise<ILocationResponse> => {
  const url = `${zps_ea_war}/shop?currencies=${currencies}&entid=${entid}&sid=${sid}`;
  return axios.get<ILocationResponse>(url).then(res => res.data);
};

export const addLocation = (payload: LocationRequest, controller: AbortController): Promise<ILocationResponse> => {
  return axios
    .post<ILocationResponse>(`${zps_ea_war}/shop`, payload, { signal: controller.signal })
    .then(res => res.data);
};

export const updateLocation = (payload: LocationRequest, controller: AbortController): Promise<ILocationResponse> => {
  return axios
    .put<ILocationResponse>(`${zps_ea_war}/shop`, payload, { signal: controller.signal })
    .then(res => res.data);
};

export const deleteLocation = (entid: number, sid: number): Promise<ILocationResponse> => {
  return axios.delete<ILocationResponse>(`${zps_ea_war}/shop?entid=${entid}&sid=${sid}`).then(res => res.data);
};
